/* eslint-disable max-classes-per-file */
// eslint-disable-next-line max-classes-per-file

import type LandingSectionTypeInterface from "@/utils/interfaces/LandingSectionTypeInterface";

export interface RequestFlightLandingInterface
  extends LandingSectionTypeInterface {}

export class FlightLandingInfo {
  airlineSlug: string;

  airlineName: string;

  airlineLogo: string;

  flightName: string;

  flightType: string;

  flightSlug: string;

  dateSearchDeparture: string;

  dateSearchReturn: string;

  ticketingPeriod: string;

  ticketingFromDate: string;

  ticketingToDate: string;

  travelPeriod: string;

  travelFromDate: string;

  travelToDate: string;

  fromAirportCode: string;

  toAirportCode: string;

  fromAirportCityName: string;

  toAirportCityName: string;

  price: number;

  photoPath: string;

  isRecommended: boolean;

  isSpecialDeal: boolean;

  perks?: string;

  constructor(flightInfo?: FlightLandingInfo) {
    this.airlineSlug = flightInfo?.airlineSlug || "";
    this.airlineName = flightInfo?.airlineName || "";
    this.airlineLogo = flightInfo?.airlineLogo || "";
    this.flightName = flightInfo?.flightName || "";
    this.flightType = flightInfo?.flightType || "";
    this.flightSlug = flightInfo?.flightSlug || "";
    this.dateSearchDeparture = flightInfo?.dateSearchDeparture || "";
    this.dateSearchReturn = flightInfo?.dateSearchReturn || "";
    this.ticketingPeriod = flightInfo?.ticketingPeriod || "";
    this.ticketingFromDate = flightInfo?.ticketingFromDate || "";
    this.ticketingToDate = flightInfo?.ticketingToDate || "";
    this.travelPeriod = flightInfo?.travelPeriod || "";
    this.travelFromDate = flightInfo?.travelFromDate || "";
    this.travelToDate = flightInfo?.travelToDate || "";
    this.fromAirportCode = flightInfo?.fromAirportCode || "";
    this.toAirportCode = flightInfo?.toAirportCode || "";
    this.fromAirportCityName = flightInfo?.fromAirportCityName || "";
    this.toAirportCityName = flightInfo?.toAirportCityName || "";
    this.price = flightInfo?.price || 0;
    this.photoPath = flightInfo?.photoPath || "";
    this.isRecommended = !!flightInfo?.isRecommended;
    this.isSpecialDeal = !!flightInfo?.isSpecialDeal;
    this.perks = flightInfo?.perks;
  }
}

class Tab {
  tabName: string;

  flightInfo: FlightLandingInfo[];

  constructor(tab?: Tab) {
    this.tabName = tab?.tabName || "";
    this.flightInfo = (tab?.flightInfo || []).map(
      (info) => new FlightLandingInfo(info),
    );
  }
}

export class DataFlightLanding {
  landingName: string;

  sectionType: string;

  currency: string;

  tabs: Tab[];

  constructor(data?: DataFlightLanding) {
    this.landingName = data?.landingName || "";
    this.sectionType = data?.sectionType || "";
    this.currency = data?.currency || "";
    this.tabs = (data?.tabs || []).map((tab) => new Tab(tab));
  }
}

export class ResponseFlightLanding {
  version: string;

  status: boolean;

  code: string;

  message: string;

  data: DataFlightLanding | null;

  constructor(data?: ResponseFlightLanding) {
    this.version = data?.version || "";
    this.status = data?.status || false;
    this.code = data?.code || "";
    this.message = data?.message || "";
    this.data = new DataFlightLanding(data?.data || ({} as DataFlightLanding));
  }
}
